import { Select, MenuItem, type SelectChangeEvent } from "@mui/material";
import type { TileSourceDef, TileSourceId } from "./tileSources";

interface TileSourceControlProps {
	tileSources: TileSourceDef[];
	value: TileSourceId;
	onChange: (id: TileSourceId) => void;
}

export function TileSourceControl({ tileSources, value, onChange }: TileSourceControlProps) {
	const handleChange = (e: SelectChangeEvent<string>) => {
		onChange(e.target.value as TileSourceId);
	};

	return (
		<Select
			size="small"
			value={value}
			onChange={handleChange}
			sx={{
				position: "absolute",
				top: 8,
				right: 8,
				zIndex: 1,
				fontSize: "0.75rem",
				bgcolor: "rgba(255,255,255,0.85)",
				borderRadius: 1,
				minWidth: 120,
				"& .MuiSelect-select": { py: 0.5, px: 1 },
			}}
		>
			{tileSources.map((ts) => (
				<MenuItem key={ts.id} value={ts.id} sx={{ fontSize: "0.75rem" }}>
					{ts.label}
				</MenuItem>
			))}
		</Select>
	);
}
